/**
 * Обложка вещи, у которой нет фотографии.
 *
 * Магазин отдаёт снимок далеко не всегда: часть площадок закрыта антиботом,
 * часть желаний человек пишет руками. Раньше в таких карточках стоял один и
 * тот же серый подарок, и список из шести желаний читался как страница,
 * которая не догрузилась. Обложка решает это без единого запроса наружу:
 * оттенок и буква считаются из самого названия.
 *
 * Здесь, в общем модуле, а не в карточке желания: ту же обложку показывает
 * мозаика на карточке списка, и два независимых расчёта разъехались бы в
 * цвете при первой же правке (constant-list-outlives-the-files-it-came-from).
 */

/**
 * Отобранные оттенки, а не весь круг.
 *
 * Первый заход брал оттенок как остаток от деления на 360, и это было видно:
 * рядом оказывались болотный, горчичный и салатный — цвета, к фиолетовому
 * вечеру продукта отношения не имеющие. Шесть тонов держат обложки одной
 * семьёй: четыре холодных из родного диапазона и два тёплых для разнообразия
 * в длинном списке.
 */
export const COVER_HUES = [232, 265, 292, 330, 38, 178];

/** Оттенок обложки. Из названия, поэтому не меняется от захода к заходу. */
export function hueFromTitle(title: string): number {
  let sum = 0;
  for (let i = 0; i < title.length; i += 1) sum = (sum + title.charCodeAt(i) * (i + 1)) % 4096;
  return COVER_HUES[sum % COVER_HUES.length] as number;
}

/**
 * Первая буква названия.
 *
 * Через Intl.Segmenter, а не `title[0]`: составные знаки (эмодзи, буквы с
 * диакритикой) в UTF-16 занимают две ячейки, и срез по индексу разрубил бы их
 * пополам — на экране вышел бы знак вопроса в ромбе.
 */
export function firstGrapheme(title: string): string {
  const clean = title.trim();
  if (!clean) return '';
  const Segmenter = (Intl as unknown as { Segmenter?: typeof Intl.Segmenter }).Segmenter;
  if (Segmenter) {
    for (const part of new Segmenter('ru', { granularity: 'grapheme' }).segment(clean)) {
      return part.segment.toUpperCase();
    }
  }
  // Запасной путь для сред без Intl.Segmenter: пара суррогатов берётся целиком.
  return [...clean][0]?.toUpperCase() ?? '';
}
